import { Header } from "@/components/layout/Header";
import { StudentBulkActions } from "@/components/nurse/StudentBulkActions";
import { StudentBulkEdit } from "@/components/nurse/StudentBulkEdit";
import { StudentList } from "@/components/nurse/StudentList";
const Students = () => {
  return <div className="min-h-screen bg-background">
      <Header />
      <main className="container mx-auto p-6 pt-[160px] space-y-6">
        <h1 className="text-3xl font-bold my-[29px]">Student Management</h1>
        <StudentBulkActions />
        <StudentBulkEdit />
        <StudentList />
      </main>
    </div>;
};
export default Students;